// Styles
import './_main-page.scss';